import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

type Props = {
  enabled: boolean;
  delay?: number;
  onPostSubmit?: () => void;
};

export const usePostSubmit = ({
  enabled = true,
  delay = 3000,
  onPostSubmit,
}: Props) => {
  const {
    formState: { isSubmitting, isValid },
  } = useFormContext();
  const [postSubmit, setPostSubmit] = useState(false);

  useEffect(() => {
    if (!enabled || !isValid) return;
    let timeout: ReturnType<typeof setTimeout>;

    if (isSubmitting) {
      setPostSubmit(true);
    } else if (postSubmit) {
      timeout = setTimeout(() => {
        setPostSubmit(false);
        onPostSubmit?.();
      }, delay);
    }

    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [isSubmitting, enabled, postSubmit, delay, onPostSubmit, isValid]);

  return [postSubmit && !isSubmitting, setPostSubmit] as const;
};
